import Vue from 'vue'

const LoginUtils = {

    authenticate(login, password) {
        return Vue.axios
            .get(`authentication`, {
                headers: {Authorization: 'IPC ldHSkkuDq7wggtFlSD9FRkItA2fqLqZf'},
                params: {
                    username: login,
                    password: password
                }
            })
            .then(response => {
                saveToken(response.data.token);
                saveUser(response.data);
                return response;
            });
    },
    findUser() {
        return Vue.axios
            .get(`gpxUser`)
            .then(response => {
                saveUser(response.data);
            });
    }

}

function saveToken(token) {
    localStorage.setItem('token', token);
    Vue.axios.defaults.headers.common['Authorization'] = 'IPC ' + token;
}

function saveUser(user) {
    localStorage.setItem('user', JSON.stringify(user));
}

export default LoginUtils;
